import PresentationViewer from "../../../components/presentations/presentationViewer";

/** Viewer fullscreen compartilha o mesmo iframe do desktop. */
export default function MobilePresentationViewer() {
  return (
    <div className="-mx-0 min-h-[70vh]">
      <PresentationViewer />
    </div>
  );
}
